/**
 * GreenRouter UI common elements sizes.
 */
export enum LayoutElementSizes {
	SideMenuWidth = 250,
}

/**
 * GreenRouter UI common animation values.
 */
export enum AnimationValues {
	SnackbarAutoHideDuration = 5000,
}
